// extracted by mini-css-extract-plugin
export default {"nav":"BottomNav_nav__SAGER","navLinks":"BottomNav_navLinks__SjEka","plusIcon":"BottomNav_plusIcon__SDDkF","activeTab":"BottomNav_activeTab__r0iU5"};